// eslint-disable-next-line unicorn/prevent-abbreviations
import template from './dev6.html';
import controller from './dev6.controller';
import './dev6.scss';

export default {
	template,
	controller,
	title: 'dev6',
	path: '/dev6',
	onlyDev: true,
	controllerAs: 'ctrl',
};
